export const eventHandlers = {
  PRODUCT_SEARCH_START_PAGE_VIEW: 'PRODUCT_SEARCH_START_PAGE_HIT',
};
